import { DashboardOutlined } from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
const icons = {
  DashboardOutlined,
};
const dashBoardNavTree = [
  {
    key: "home",
    path: `${APP_PREFIX_PATH}/home`,
    title: "home",
    icon: icons["DashboardOutlined"],
    breadcrumb: true,
    submenu: [
      {
        key: "table",
        path: `${APP_PREFIX_PATH}/table`,
        title: "Table",
        icon: icons["DashboardOutlined"],
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "forms",
        path: `${APP_PREFIX_PATH}/forms`,
        title: "Forms",
        icon: icons["DashboardOutlined"],
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "recruitment-form",
        path: `${APP_PREFIX_PATH}/recruitment-form`,
        title: "Recruitment form",
        icon: icons["DashboardOutlined"],
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "hr-form",
        path: `${APP_PREFIX_PATH}/hr-form`,
        title: "For human resources only form",
        icon: icons["DashboardOutlined"],
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "principal-form",
        path: `${APP_PREFIX_PATH}/principal-form`,
        title: "Principal form",
        icon: icons["DashboardOutlined"],
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
  
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
